// Keyboard bindings active while a card is lifted.
//   ←        → mark Unknown
//   →, Space → mark Known
//   Esc      → dismiss

import { useEffect } from "react";

interface Args {
  enabled: boolean;
  onUnknown: () => void;
  onKnown: () => void;
  onDismiss: () => void;
}

export function useKeyboardReview({
  enabled,
  onUnknown,
  onKnown,
  onDismiss,
}: Args): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      switch (e.key) {
        case "ArrowLeft":
          e.preventDefault();
          onUnknown();
          break;
        case "ArrowRight":
        case " ":
          e.preventDefault();
          onKnown();
          break;
        case "Escape":
          e.preventDefault();
          onDismiss();
          break;
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [enabled, onUnknown, onKnown, onDismiss]);
}
